import React from "react";
import ActivityAvailable from "../../../../assets/activityAvailable.svg";
import ActivitySidikJari from "../../../../assets/sidikjari.svg";
import ActivityGembok from "../../../../assets/gembok.svg";
import ActivityHand from "../../../../assets/hand.svg";

export default function Activity() {
  const listItem = [
    {
      icon: ActivitySidikJari,
      title: "Identitas",
      desc: "Data pembuatan TTE terkait hanya kepada Penanda Tangan Data pembuatan TTE pada saat proses penandatanganan elektronik hanya berada dalam kuasa Penanda Tangan",
    },
    {
      icon: ActivityGembok,
      title: "Integritas",
      desc: "Segala perubahan terhadap TTE yang terjadi setelah waktu penandatangan dapat diketahui Segala perubahan terhadap informasi Elektronik yang terkait dengan TTE tersebut setelah waktu penandatangan dapat diketahui",
    },
    {
      icon: ActivityHand,
      title: "Nirsangkal",
      desc: `Terdapat cara tertentu yang dipakai untuk 
      mengidentifikasi siapa penandatangannya 
      
      Terdapat cara tertentu untuk menunjukan bahwa 
      Penanda Tangan telah memberikan persetujuan 
      terhadap Informasi Elektronik yang terkait`,
    },
  ];

  return (
    <section className="psre-satu">
      <div className="container">
        <h6
          className="h6-nunito"
          style={{ marginLeft: "0px", marginTop: "70px", fontWeight: 700 }}
        >
          Jaminan Tanda Tangan Elektronik (TTE)
        </h6>
        <p className="p-nunito" style={{ margin: "0px" }}>
          Tanda Tangan Elektronik memiliki kekuatan hukum dan akibat hukum yang
          sah selama memenuhi persyaratan sebagai berikut ;
        </p>
        <div className="row" style={{ marginTop: "40px", flexWrap: "wrap" }}>
          <div className="col-md-4" style={{ padding: "0px 8px" }}>
            <img
              className="mb-0"
              src={ActivitySidikJari}
              alt="icon"
              style={{ height: "40px", objectFit: "contain" }}
            />
            <div style={{ height: 35 }} className="d-none d-md-flex" />
            <div style={{ height: 20 }} className="d-flex d-md-none" />
            <h6
              className="h6-nunito"
              style={{
                fontWeight: 700,
              }}
            >
              Identitas
            </h6>
            <div style={{ height: 30 }} className="d-none d-md-block" />
            <div style={{ height: 10 }} className="d-flex d-md-none" />
            <p style={{ marginBottom: "10px" }} className="p-nunito">
              Data pembuatan TTE{" "}
              <span style={{ color: "#1672BD" }}>terkait hanya</span> kepada
              Penanda Tangan
            </p>
            <p style={{ margin: "0px" }} className="p-nunito">
              Data pembuatan TTE pada saat proses penandatanganan elektronik{" "}
              <span style={{ color: "#1672BD" }}>hanya berada dalam kuasa</span>{" "}
              Penanda Tangan
            </p>
            <div style={{ height: 20 }} className="d-flex d-md-none" />
          </div>
          <div className="col-md-4" style={{ padding: "0px 8px" }}>
            <img
              className="mb-0"
              src={ActivityGembok}
              alt="icon"
              style={{ height: "40px", objectFit: "contain" }}
            />
            <div style={{ height: 35 }} className="d-none d-md-flex" />
            <div style={{ height: 20 }} className="d-flex d-md-none" />
            <h6
              className="h6-nunito"
              style={{
                fontWeight: 700,
              }}
            >
              Integritas
            </h6>
            <div style={{ height: 30 }} className="d-none d-md-block" />
            <div style={{ height: 10 }} className="d-flex d-md-none" />
            <p style={{ marginBottom: "10px" }} className="p-nunito">
              Segala{" "}
              <span style={{ color: "#1672BD" }}>perubahan terhadap TTE</span>{" "}
              yang terjadi setelah waktu penandatangan dapat diketahui.
            </p>

            <p style={{ margin: "0px" }} className="p-nunito">
              Segala{" "}
              <span style={{ color: "#1672BD" }}>
                perubahan terhadap informasi Elektronik
              </span>{" "}
              yang terkait dengan TTE tersebut setelah waktu penandatangan dapat
              diketahui
            </p>
            <div style={{ height: 20 }} className="d-flex d-md-none" />
          </div>
          <div className="col-md-4" style={{ padding: "0px 8px" }}>
            <img
              className="mb-0"
              src={ActivityHand}
              alt="icon"
              style={{ height: "40px", objectFit: "contain" }}
            />
            <div style={{ height: 35 }} className="d-none d-md-flex" />
            <div style={{ height: 20 }} className="d-flex d-md-none" />
            <h6
              className="h6-nunito"
              style={{
                fontWeight: 700,
              }}
            >
              Nirsangkal
            </h6>
            <div style={{ height: 30 }} className="d-none d-md-block" />
            <div style={{ height: 10 }} className="d-flex d-md-none" />
            <p style={{ marginBottom: "10px" }} className="p-nunito">
              Terdapat cara tertentu yang dipakai untuk{" "}
              <span style={{ color: "#1672BD" }}>mengidentifikasi siapa </span>
              penandatangannya
            </p>
            <p style={{ margin: "0px" }} className="p-nunito">
              Terdapat cara tertentu untuk menunjukan bahwa Penanda Tangan telah{" "}
              <span style={{ color: "#1672BD" }}>memberikan persetujuan</span>{" "}
              terhadap Informasi Elektronik yang terkait
            </p>
            <div style={{ height: 20 }} className="d-flex d-md-none" />
          </div>
        </div>
        {/* <div className="row d-sm-none d-md-flex d-none" style={{ marginTop: "60px" }}>
          {listItem.map((item) => (
            <div className="col-md-4" style={{padding: '0px 8px'}}>
              <img
                className="mb-0"
                src={item.icon}
                alt="icon"
                style={{ height: "40px", objectFit: "contain" }}
              />
              <h6 className="h6-nunito" style={{ fontWeight: 700, marginTop: '35px', marginBottom: '30px' }}>
                {item.title}
              </h6>
              <p style={{margin: '0px'}} className="p-nunito">{item.desc}</p>
            </div>
          ))}
        </div>
        <div className="row d-md-none d-flex" style={{ marginTop: "25px" }}>
          {listItem.map((item) => (
            <div className="col-md-4 col-sm-12 col-12" style={{padding: '0px 8px', marginBottom: 20, }}>
              <img
                className="mb-0"
                src={item.icon}
                alt="icon"
                style={{ height: "40px", objectFit: "contain" }}
              />
              <h6 className="h6-nunito" style={{ fontWeight: 700, marginTop: '10px', marginBottom: '5px' }}>
                {item.title}
              </h6>
              <p style={{margin: '0px'}} className="p-nunito">{item.desc}</p>
            </div>
          ))}
        </div> */}
        <div style={{ height: 20 }} />
        <div
          style={{
            height: "1px",
            backgroundColor: "#E5E5E5",
            marginTop: "30px",
          }}
        />
      </div>
    </section>
  );
}
